import React, {PropsWithRef, useState} from 'react';
import MsgBox from "../components/popups/MessageBox";

export interface IMessageBoxProps {
    onConfirme?: () => void,
    onAnnuler?: () => void,
}

function useMessageBox() {
    const [isMessageBoxOpen, setIsMessageBoxOpen] = useState(false)
    const [title, setTitle] = useState("")
    const [message, setMessage] = useState("")
    const [buttonType, setButtonType] = useState<"OuiNon" | "Ok" | "OkAnnuler">("Ok")
    const MessageBox = ({onConfirme, onAnnuler}: PropsWithRef<IMessageBoxProps>) => {
        return <MsgBox isOpen={isMessageBoxOpen} message={message} title={title} buttonType={buttonType} onAnnuler={() => {
            onAnnuler && onAnnuler();
            setIsMessageBoxOpen(false)
        }} onConfirme={() => {
            onConfirme && onConfirme()
            setIsMessageBoxOpen(false)
        }}/>
    }

    return {
        isMessageBoxOpen,
        setIsMessageBoxOpen,
        setTitle,
        setMessage,
        setButtonType,
        MessageBox
    };
}

export default useMessageBox;